export type QuestionAnswer = {
  assistant: string;
  user: string;
}

export type ChatRequest = {
  jsonResponse: boolean,
  messages: QuestionAnswer[];
  context: string;
}

export async function sendMessageToChatGPT(requestData: ChatRequest) {
  console.log("Start fetching");
  try {
    const response = await fetch('/api/chat-gpt', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });
    console.log("Fetched");
    
    if (!response.ok) {
      const code = response.status;
      const error = await response.json();
      alert("Error while communicationg with ChatGPT. The error message:\n"+code+": "+JSON.stringify(error));
      console.log("Error while communicationg with ChatGPT. The error message: "+code+": "+error);
      
      throw new Error('Network response was not ok: '+code+": "+error);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    return "";
  }
};